import { memo } from 'react'
import useTimeTicker, { TimeTickerPropsType } from './useTimeTicker'

const TimeTicker = ({ data }: { data: TimeTickerPropsType }) => {
  const { renderTimer } = useTimeTicker(data)
  return <>{renderTimer()}</>
}

export default memo(TimeTicker)
